import angular from 'angular';

export default angular.module('components.kb', [])
    .component('kb', {
        template: require('./kb.pug')(),
        controller: ['$state', 'CatalogService', function($state, CatalogService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.load();
            };

            ctrl.load = function() {
                CatalogService.get({}).$promise.then(function(response) {
                    ctrl.content = response;
                });
            };
        }]
    })
    .component('kbAdvanced', {
        template: require('./kbAdvanced.pug')()
    })
    .value('KBConfig', {
    })
    .name; 
